import { render, staticRenderFns } from "./InputSpin.vue?vue&type=template&id=4e56c6fc&scoped=true&"
import script from "./InputSpin.vue?vue&type=script&lang=js&"
export * from "./InputSpin.vue?vue&type=script&lang=js&"
import style0 from "./InputSpin.vue?vue&type=style&index=0&id=4e56c6fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56c6fc",
  null
  
)

export default component.exports